/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the internal state of the Legal Case. <ul><li>Inactive - Initial state when the case is created, and none of the prerequisites are met.</li><li>RegistrationOnly  - We allow only client registrations and the process ends with notifying the client that we have received the registration. The Client Portal is not open, and the Sign-In does not work at this point. </li><li>ClientZoneOnly  - Only the Client Portal is open - clients can only be manually created or invited to the Case. Registration is disabled.</li><li>FullyEnabled  - Case allows the entire client workflow - registration and client portal are opened to client for a given case.</li><li>Archived  - The case is transferred to R/O state - this operation is irreversible. </li></ul>
 */
export const CaseStatus = {
    Inactive: 1,
    RegistrationOnly: 2,
    ClientZoneOnly: 3,
    FullyEnabled: 4,
    Archived: 5
} as const;
export type CaseStatus = typeof CaseStatus[keyof typeof CaseStatus];

